import { getFirstNetToken } from "@erinfo/provider/src/data/index"
import { Dispatch, RootState } from "@erinfo/provider/src/store"
import { useRematchDispatch } from "@erinfo/react-utils/src/hooks"
import { Box } from "@mui/material"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { Navigate, useLocation, useNavigate } from "react-router-dom"

const OAuth = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { storeProviderById } = useRematchDispatch((dispatch: Dispatch) => ({
    storeProviderById: dispatch.user.storeProviderById,
  }))
  const user = useSelector((state: RootState) => state.user)

  const retrieveToken = async () => {
    const hash = location.hash

    const items = hash.split(`&`)
    const code = items.find((item) => item.includes(`code`))
    const state = items.find((item) => item.includes(`state`))

    const [_, codeValue] = code?.split(`=`) ?? []
    const [__, stateValue] = state?.split(`=`) ?? []

    const response = await getFirstNetToken(codeValue, stateValue)
    const { redirectUri, ...payload } = response || {}

    /** Used for local development to redirect to localhost or native app
     *   - in this case, backend doesn't return the "token", only the "redirectUri" */
    if (redirectUri) return window.open(redirectUri, `_self`)

    const isSuccess = payload.token && payload.sub
    const type = `OAUTH_${isSuccess ? `SUCCESS` : `ERROR`}`

    const runFallback = () => {
      if (isSuccess) {
        void storeProviderById(payload)
        navigate(`/app/identify`)
      } else navigate(`/`) // if this URL is opened directly in the browser, redirect to home
    }

    if (process.env.NATIVE_APP || process.env.NODE_ENV === `development`) {
      runFallback()
    } else {
      const isOpenedByAnotherWindow = window.opener && !window.opener.closed
      if (isOpenedByAnotherWindow) {
        window.opener.postMessage({ ...payload, type }, window.location.origin)
        window.close()
      } else {
        runFallback()
      }
    }
  }

  useEffect(() => {
    void retrieveToken()
  }, [location.hash])

  return user?.token ? (
    <Navigate to="/app/identify" />
  ) : (
    <Box sx={{ marginTop: 2 }}>
      <h1>Loading...</h1>
    </Box>
  )
}

export default OAuth
